import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './admin.component';
import {AuthGuard} from "./auth/auth.guard";
import { ProfilePage } from './profile/profile.page';

const routes: Routes = [
  {
    path: 'admin-tabs',
    redirectTo: 'admin-expert-settings',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_EXPERT'
    }
  },
	{
    path: '',
    loadChildren: () => import('./admin-tabs/admin-tabs.module').then(m => m.AdminTabsPageModule)
  },
/*   {
    path: 'dashboard',
    loadChildren: () => import('./profile/profile.module').then( m => m.ProfilePageModule),
    canActivate: [AuthGuard],
    data : {
      role: 'ROLE_ADMIN'
    }
  },
  { path: '', redirectTo:'dashboard', pathMatch: 'full'}, */
  {
    path: 'admin-expert-settings',
    loadChildren: () => import('./admin-expert-settings/admin-expert-settings.module').then( m => m.AdminExpertSettingsPageModule)
  },
  {
    path: 'admin-account',
    loadChildren: () => import('./admin-account/admin-account.module').then( m => m.AdminAccountPageModule)
  },
  {
    path: 'admin-system-contents',
    loadChildren: () => import('./admin-system-contents/admin-system-contents.module').then( m => m.AdminSystemContentsPageModule)
  },
  {
    path: 'admin-questions-settings',
    loadChildren: () => import('./admin-questions-settings/admin-questions-settings.module').then( m => m.AdminQuestionsSettingsPageModule)
  },
  {
    path: 'admin-rates-settings',
    loadChildren: () => import('./admin-rates-settings/admin-rates-settings.module').then( m => m.AdminRatesSettingsPageModule)
  },
  {
    path: 'admin-hospital-settings',
    loadChildren: () => import('./admin-hospital-settings/admin-hospital-settings.module').then( m => m.AdminHospitalSettingsPageModule)
  },  {
    path: 'admin-expert-pending-detail-modal',
    loadChildren: () => import('./admin-expert-pending-detail-modal/admin-expert-pending-detail-modal.module').then( m => m.AdminExpertPendingDetailModalPageModule)
  },
  {
    path: 'admin-expert-detail-modal',
    loadChildren: () => import('./admin-expert-detail-modal/admin-expert-detail-modal.module').then( m => m.AdminExpertDetailModalPageModule)
  },
  {
    path: 'admin-country-modal',
    loadChildren: () => import('./admin-country-modal/admin-country-modal.module').then( m => m.AdminCountryModalPageModule)
  },
  {
    path: 'admin-city-modal',
    loadChildren: () => import('./admin-city-modal/admin-city-modal.module').then( m => m.AdminCityModalPageModule)
  },
  {
    path: 'admin-city-list-by-country-modal',
    loadChildren: () => import('./admin-city-list-by-country-modal/admin-city-list-by-country-modal.module').then( m => m.AdminCityListByCountryModalPageModule)
  },
  {
    path: 'admin-town-list-by-city-modal',
    loadChildren: () => import('./admin-town-list-by-city-modal/admin-town-list-by-city-modal.module').then( m => m.AdminTownListByCityModalPageModule)
  },
  {
    path: 'admin-towns-modal',
    loadChildren: () => import('./admin-towns-modal/admin-towns-modal.module').then( m => m.AdminTownsModalPageModule)
  },
  {
    path: 'admin-town-city-choose-layer-modal',
    loadChildren: () => import('./admin-town-city-choose-layer-modal/admin-town-city-choose-layer-modal.module').then( m => m.AdminTownCityChooseLayerModalPageModule)
  },
  {
    path: 'admin-system-languages-modal',
    loadChildren: () => import('./admin-system-languages-modal/admin-system-languages-modal.module').then( m => m.AdminSystemLanguagesModalPageModule)
  },
  {
    path: 'admin-system-insurances-modal',
    loadChildren: () => import('./admin-system-insurances-modal/admin-system-insurances-modal.module').then( m => m.AdminSystemInsurancesModalPageModule)
  },
  {
    path: 'admin-branches-modal',
    loadChildren: () => import('./admin-branches-modal/admin-branches-modal.module').then( m => m.AdminBranchesModalPageModule)
  },
  {
    path: 'admin-branch-interest-layer-modal',
    loadChildren: () => import('./admin-branch-interest-layer-modal/admin-branch-interest-layer-modal.module').then( m => m.AdminBranchInterestLayerModalPageModule)
  },
  {
    path: 'admin-interest-modal',
    loadChildren: () => import('./admin-interest-modal/admin-interest-modal.module').then( m => m.AdminInterestModalPageModule)
  },
  {
    path: 'admin-branch-services-modal',
    loadChildren: () => import('./admin-branch-services-modal/admin-branch-services-modal.module').then( m => m.AdminBranchServicesModalPageModule)
  },
  {
    path: 'admin-branch-services-layer-modal',
    loadChildren: () => import('./admin-branch-services-layer-modal/admin-branch-services-layer-modal.module').then( m => m.AdminBranchServicesLayerModalPageModule)
  },
  {
    path: 'admin-branch-group-modal',
    loadChildren: () => import('./admin-branch-group-modal/admin-branch-group-modal.module').then( m => m.AdminBranchGroupModalPageModule)
  },
  {
    path: 'admin-branch-group-layer-modal',
    loadChildren: () => import('./admin-branch-group-layer-modal/admin-branch-group-layer-modal.module').then( m => m.AdminBranchGroupLayerModalPageModule)
  },
  {
    path: 'admin-branch-interest-choose-layer-modal',
    loadChildren: () => import('./admin-branch-interest-choose-layer-modal/admin-branch-interest-choose-layer-modal.module').then( m => m.AdminBranchInterestChooseLayerModalPageModule)
  },
  {
    path: 'admin-branch-services-choose-group-layer-modal',
    loadChildren: () => import('./admin-branch-services-choose-group-layer-modal/admin-branch-services-choose-group-layer-modal.module').then( m => m.AdminBranchServicesChooseGroupLayerModalPageModule)
  },
  {
    path: 'admin-blog-categories',
    loadChildren: () => import('./admin-blog-categories/admin-blog-categories.module').then( m => m.AdminBlogCategoriesPageModule)
  },
  {
    path: 'admin-blog-add',
    loadChildren: () => import('./admin-blog-add/admin-blog-add.module').then( m => m.AdminBlogAddPageModule)
  },
  {
    path: 'admin-blog-update',
    loadChildren: () => import('./admin-blog-update/admin-blog-update.module').then( m => m.AdminBlogUpdatePageModule)
  },
  {
    path: 'admin-first-aid-categories',
    loadChildren: () => import('./admin-first-aid-categories/admin-first-aid-categories.module').then( m => m.AdminFirstAidCategoriesPageModule)
  },
  {
    path: 'admin-first-aid-add',
    loadChildren: () => import('./admin-first-aid-add/admin-first-aid-add.module').then( m => m.AdminFirstAidAddPageModule)
  },
  {
    path: 'admin-question-detail',
    loadChildren: () => import('./admin-question-detail/admin-question-detail.module').then( m => m.AdminQuestionDetailPageModule)
  },
  {
    path: 'admin-feedbacks',
    loadChildren: () => import('./admin-feedbacks/admin-feedbacks.module').then( m => m.AdminFeedbacksPageModule)
  },
  {
    path: 'admin-comments',
    loadChildren: () => import('./admin-comments/admin-comments.module').then( m => m.AdminCommentsPageModule)
  },
  {
    path: 'admin-expert-review-profile-modal',
    loadChildren: () => import('./admin-expert-review-profile-modal/admin-expert-review-profile-modal.module').then( m => m.AdminExpertReviewProfileModalPageModule)
  }



];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule {}